import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "react-toastify";

const scrollReveal = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const staggerContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.4 } },
};

const IndianTaxAdvisorycomponents = () => {
    const steps = [
        {
            description: "Direct Taxation: Corporate and Individual Income Tax planning."
        },
        {
            description: "Expert management of TDS/TCS compliance."
        },
        {
            description: "International Tax & Transfer Pricing (TP) for cross-border operations."
        },
        {
            description: "Indirect Taxation (GST):End-to-end GST lifecycle management from registration to annual filings."
        },
        {
            description: "ITC Optimization: Rigorous reconciliation of GSTR-2B with purchase registers to ensure no tax credit is lost."
        },
        {
            description: "Tax Litigation: Representation before departmental authorities and appellate tribunals."
        }
    ];

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        serviceType: "Indian Tax Advisory (Direct & Indirect)",
        message: ""
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === "mobile") {
            value = value.replace(/^\+?91/, "");
            value = value.replace(/^0+/, "");
            value = value.replace(/\s/g, "");
            value = value.replace(/\D/g, "");
            value = value.slice(0, 10);
        }

        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/contact`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            });
            const res = await response.json();
            if (response.ok) {
                toast.success("Details sent, Our team will contact you soon", {
                    position: "top-center",
                    autoClose: 3000
                });
                setFormData({
                    name: "",
                    email: "",
                    mobile: "",
                    serviceType: "Indian Tax Advisory (Direct & Indirect)",
                    message: ""
                });
                setLoading(false);
            }
            setLoading(false);
        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 3000
            });
            setLoading(false);
        }
    };

    return (
        <motion.div
            className="loan-steps-main-smco"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
        >


            <motion.div className="loan-container-smco" variants={staggerContainer}>
                <motion.div className="loan-step-left-container-smco" variants={staggerContainer}>
                    <motion.h2 className="loan-step-left-container-title-smco" variants={scrollReveal}>
                        We provide comprehensive Indian tax advisory services.
                    </motion.h2>
                    <motion.div className="loan-step-left-container-timeline-smco" variants={staggerContainer}>
                        {steps.map((step, index) => (
                            <motion.div
                                key={index}
                                className={`loan-step-left-container-step-smco ${index === steps.length - 1 ? 'loan-step-left-container-last-step-smco' : ''}`}
                                variants={scrollReveal}
                            >
                                <motion.div className="loan-step-left-container-number-smco" variants={scrollReveal}>
                                    {index + 1}
                                </motion.div>
                                <motion.p className="loan-step-left-container-description-smco" variants={scrollReveal}>
                                    {step.description}
                                </motion.p>
                            </motion.div>
                        ))}
                    </motion.div>
                </motion.div>
                <motion.div className="loan-step-right-container-smco" variants={staggerContainer}>
                    <motion.h3 className="contact-us-header-smco" variants={scrollReveal}>Contact Us for Indian tax advisory</motion.h3>
                    <form onSubmit={handleSubmit}>
                        <label>Name</label>
                        <input type="text" name="name" value={formData.name} className="contact-page-smco-input" onChange={handleChange} placeholder="Your Name" />

                        <label>Email</label>
                        <input type="email" name="email" value={formData.email} className="contact-page-smco-input" onChange={handleChange} placeholder="Your Email" />

                        <label>Phone Number</label>
                        <input type="text" name="mobile" value={formData.mobile} className="contact-page-smco-input" placeholder="Your Number" onChange={handleChange}/>

                        <label>Service Type</label>
                        <select className="contact-page-smco-input" name="serviceType" value={formData.serviceType} onChange={handleChange} required>
                            <option value="Indian Tax Advisory (Direct & Indirect)">Indian Tax Advisory (Direct & Indirect)</option>
                        </select>

                        <label>Message</label>
                        <textarea className="contact-page-smco-input" placeholder="Your Message" name="message" value={formData.message} onChange={handleChange}></textarea>

                        <button type="submit" className="contact-page-smco-button">
                            {loading ? <span className="spinner"></span> : "Submit"}
                        </button>
                    </form>
                </motion.div>
            </motion.div>
        </motion.div>
    );
};

export default IndianTaxAdvisorycomponents;
